if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.dpx-main-product');
      this.productInfo = this.productSection.querySelectorAll('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.submitBtn = this.querySelector("button.btn");
      this.price = this.querySelector(".price__current");
      this.variants = this.querySelectorAll(".card__options--option")

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo[this.productInfo.length - 1] && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm){
        observer.observe(this.productForm);

        if (theme.settings.afterAtc !== 'no-js') {
          this.productForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      if (this.productInfo[this.productInfo.length - 1]) observer.observe(this.productInfo[this.productInfo.length - 1]);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      document.addEventListener('on:variant:change', this.onVariantChange.bind(this));
      document.addEventListener('on:cart:add', this.handleAddSuccess.bind(this));
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    onVariantChange(evt) {
      if (evt.detail.variant) {
        const variant = evt.detail.variant;
        const data = JSON.parse(document.getElementById("option-json").textContent);

        this.price.innerHTML = data.formatted[variant.id].price;
        this.variants.forEach((option, index)=>{
          option.querySelector(".option__value").innerHTML = variant.options[index];
        });
      }
    }

    handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form' || this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
    }

    handleAddSuccess(evt) {
      // Re-enable 'Add to Cart' button.
      this.submitBtn.classList.add('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }, 1400);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
